import React from 'react';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon({
  title: 'facebook',
  width: '37.53',
  height: '32.51',
  viewBox: '0 0 37.53 32.51',
  content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("polygon", {
    points: "18.77 4 25.58 15.8 27.25 14.69 18.77 0 12.29 11.22 14.01 12.25 18.77 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.53 32.51 29.7 18.94 27.99 19.97 34.07 30.51 3.46 30.51 9.34 20.33 7.6 19.34 0 32.51 37.53 32.51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "16.77",
    y: "11.51",
    width: "3",
    height: "11",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "21.11",
    y: "19.01",
    width: "6.32",
    height: "3",
    transform: "translate(-2.87 37.04) rotate(-71.55)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "10.27",
    y: "13.29",
    width: "3",
    height: "10.44",
    transform: "translate(-4.82 4.16) rotate(-16.7)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "14.27",
    cy: "27.01",
    r: "1.5",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18.27",
    cy: "26.01",
    r: "1.5",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "22.27",
    cy: "27.01",
    r: "1.5",
    fill: "#e60000"
  }))
});